import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@facet-wealth/design';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Button from 'Components/UI/Button';
import CircularProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/CircularProgress';
import { useSnackbarContext } from 'Context/SnackbarContext';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';

const styles = (theme) => ({
  root: {},
  spacing: {
    marginBottom: theme.spacing(4),
  },
  fields: {
    padding: theme.spacing(0),
  },
  deleteButton: {
  },
  deleteButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
});

const TransactionDetails = ({ classes }) => {
  const [loading, setLoading] = useState(false);
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const { displayErrorMessage, displaySuccess } = useSnackbarContext();

  const {
    resource,
    onSubmit,
  } = useMetaLayoutContext();

  async function handleDelete() {
    setLoading(true);
    try {
      await resource.delete();
      await refreshPageContentCollection();
      displaySuccess('Transfer Cancelled');
      clearModalCollection();
    } catch (e) {
      displayErrorMessage(e, (e.errors && e.errors[0]?.detail) || 'Unable to cancel transfer. Try again later.');
    } finally {
      setLoading(false);
    }
  }

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await onSubmit();
      await refreshPageContentCollection();
      displaySuccess('Transfer Updated');
      clearModalCollection();
    } catch (e) {
      displayErrorMessage(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <PageContentTop
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <div className={classes.spacing} />
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      {resource.meta().action('DELETE')
        ? (
          <div className={classes.deleteButtonContainer}>
            <Button
              onClick={handleDelete}
              className={classes.deleteButton}
              color={'red'}
              disabled={loading}
              startIcon={(loading) ? (
                <CircularProgress
                  test="loading-indicator"
                  className={classes.buttonLoader}
                  size={12}
                />) : null
                }
            >
              {loading ? 'Cancelling Transfer' : 'Cancel Transfer'}
            </Button>
          </div>
        )
        : null}
      {resource.meta().action('PUT')
        ? (
          <div className={classes.deleteButtonContainer}>
            <Button
              onClick={handleSubmit}
              className={classes.deleteButton}
              color={'primary'}
              disabled={loading}
              startIcon={(loading) ? (
                <CircularProgress
                  test="loading-indicator"
                  className={classes.buttonLoader}
                  size={12}
                />) : null
                    }
            >
              {loading ? 'Saving Changes' : 'Save Changes'}
            </Button>
          </div>
        )
        : null}

    </Box>
  );
};

TransactionDetails.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TransactionDetails);
